@if (showSpinner()) {
  <div class="modal fixed top-0 left-0 h-screen w-full">
    <div class="modal-background"></div>
    <div class="modal-container relative flex flex-column align-items-center">
      <img class="spinner mb-6" src="/assets/images/spinner/spinner_orange.svg" alt="Icono de carga">
      <p class="primary-color">{{loadingText()}}</p>
    </div>
  </div>
}
